import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function Tier1Supplier({ tier1Supplier = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "dependency_level", label: "Dependency Level" },
        { key: "substitution_risk", label: "Substitution Risk" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        { key: "location", label: "Location" },
        { key: "material_supplied", label: "Material Supplied" },
        { key: "contract_status", label: "Contract Status" },
        { key: "dependency_level", label: "Dependency Level" },
        { key: "substitution_risk", label: "Substitution Risk" },
        { key: "strategic_notes", label: "Strategic Notes" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(tier1Supplier);
    setTabData(transformed);
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={tier1Supplier?.[0]?.response?.tableComments || ""}
      />
    );
  }, [tier1Supplier]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Potential Tier 1 Suppliers"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="supplier_name"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default Tier1Supplier;
